import { Controller } from '@hotwired/stimulus';

export default class GoBackController extends Controller {
  goBack(event) {
    event.preventDefault(); // Prevent the default anchor behavior
    history.go(-1); // Go back to the previous page
  }
}
